(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luxe-article-share"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('luxe-article-share'))customElements.define('luxe-article-share',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();
    const button=this.querySelector('[data-copy]');
    if(navigator.clipboard?.writeText){button.hidden=false;button.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(this.dataset.url);this.querySelector('[data-status]').textContent=this.dataset.copied;}catch{this.querySelector('[data-status]').textContent=this.dataset.copyError;}},{signal:this.controller.signal});}
  }
  disconnectedCallback(){this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luxe-card-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('luxe-card-purchase')){
  customElements.define('luxe-card-purchase',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.addEventListener('keydown',event=>event.stopPropagation(),options);
      this.addEventListener('keyup',event=>event.stopPropagation(),options);
      this.addEventListener('click',event=>{
        event.stopPropagation();
        if(!(event.target instanceof Element))return;
        const arrow=event.target.closest('[data-size-scroll]');
        const track=this.querySelector('.luxe-card-purchase__track');
        if(!arrow||!track)return;
        event.preventDefault();
        const direction=getComputedStyle(track).direction==='rtl'?-1:1;
        const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({left:Number(arrow.dataset.sizeScroll)*direction*Math.max(80,track.clientWidth*.65),behavior:reduced?'auto':'smooth'});
      },options);
      const track=this.querySelector('.luxe-card-purchase__track');
      if(track){
        const update=()=>{
          const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
          const offset=Math.min(maximum,Math.abs(track.scrollLeft));
          const previous=this.querySelector('[data-size-scroll="-1"]');
          const next=this.querySelector('[data-size-scroll="1"]');
          if(previous)previous.hidden=maximum<=2||offset<=2;
          if(next)next.hidden=maximum<=2||offset>=maximum-2;
        };
        track.addEventListener('scroll',update,{...options,passive:true});
        track.addEventListener('focusin',event=>{
          if(!(event.target instanceof Element))return;
          const pill=event.target.closest('.luxe-card-purchase__pill');
          if(!pill)return;
          const bounds=pill.getBoundingClientRect(),viewport=track.getBoundingClientRect();
          if(bounds.left<viewport.left+36)track.scrollBy({left:bounds.left-viewport.left-36,behavior:'auto'});
          else if(bounds.right>viewport.right-36)track.scrollBy({left:bounds.right-viewport.right+36,behavior:'auto'});
        },options);
        this.sizeObserver?.disconnect();
        if(typeof ResizeObserver!=='undefined'){
          this.sizeObserver=new ResizeObserver(update);
          this.sizeObserver.observe(track);
        }else window.addEventListener('resize',update,options);
        document.fonts?.ready.then(()=>{if(this.isConnected)update();});
        update();
      }
      this.addEventListener('change',event=>{
        if(!(event.target instanceof HTMLInputElement)||event.target.type!=='radio')return;
        const quantity=this.querySelector('input[name="quantity"]');
        if(quantity)quantity.value=event.target.dataset.minimum||'1';
        const price=this.querySelector('output');
        if(price)price.textContent=event.target.dataset.price||'';
      },options);
    }
    disconnectedCallback(){this.controller?.abort();this.sizeObserver?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luxe-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxe-collection-filters')) {
    customElements.define('luxe-collection-filters', class extends HTMLElement {
      connectedCallback() {
        this.updateLinks();
        this.addEventListener('click', this.handleClick);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }
      handleClick = () => this.updateLinks();
      updateLinks() {
        const query = new URLSearchParams(window.location.search);
        query.delete('page');
        for (const link of this.querySelectorAll('[data-luxe-tag-filter], .luxe-extra-filter__chips a')) {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          url.search = '';
          for (const [key, value] of query) url.searchParams.append(key, value);
          link.href = url.href;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luxe-size-guide-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxe-size-guide')) {
    customElements.define('luxe-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-luxe-size-open]');
          const dialog = this.querySelector('dialog');
          if (!(dialog instanceof HTMLDialogElement)) return;
          if (trigger && typeof dialog.showModal === 'function') {
            event.preventDefault();
            this.trigger = trigger;
            if (!dialog.open) dialog.showModal();
          } else if (event.target.closest('[data-luxe-size-close]')) {
            dialog.close();
          } else if (event.target === dialog && dialog.open) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          }
        }, { signal: this.controller.signal });
        this.querySelector('dialog')?.addEventListener('close', () => this.trigger?.focus(), { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.querySelector('dialog[open]')?.close();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
